import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "../../style/swiper.css";
import "../../style/animations.css";
import { useMemo } from "react";
import { useInView } from "../../hooks/useInView";
import { useHomePage } from "../../context/HomePageContext";

import { resolveClientStories } from "../../lib/homePageContent";
import { useLanguage } from "../../context/LanguageContext";

export default function ClientStorySection() {
  const { data } = useHomePage();
  const { language } = useLanguage();
  const stories = useMemo(
    () => resolveClientStories(data?.client_story, language),
    [data, language],
  );
  const { ref, inView } = useInView<HTMLDivElement>();

  // Admin mengosongkan semua testimoni -> section tidak ditampilkan.
  if (stories.items.length === 0) return null;

  return (
    <section
      className="
        w-full

    

        px-6
        py-20

        lg:px-20
        lg:py-24
      ">
      <div
        ref={ref}
        className="
          w-full
          max-w-[1327px]
          
          mx-auto
        ">
        {/* TITLE */}
        <div
          className={`
            flex
            justify-center

            mb-14

            reveal-up
            ${inView ? "is-visible" : ""}
          `}>
          <h2
            className="
              text-[#324A5A]
              text-center

              text-[34px]
              font-bold

              lg:text-[48px]
            ">
            {stories.title}
          </h2>
        </div>

        {/* SWIPER */}
        <Swiper
          modules={[Pagination]}
          pagination={{ clickable: true }}
          spaceBetween={28}
          grabCursor={true}
          breakpoints={{
            0: {
              slidesPerView: 1.1,
            },
            640: {
              slidesPerView: 1.5,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
          className="client-story-swiper pb-20">
          {stories.items.map((item, index) => (
            <SwiperSlide key={item.key}>
              <div
                style={{
                  transitionDelay: inView ? `${index * 100}ms` : "0ms",
                }}
                className={`
                  reveal-up
                  ${inView ? "is-visible" : ""}

                  bg-white

                  rounded-[24px]

                  p-6

                  h-[240px]

                  transition-all
                  duration-300

                  hover:-translate-y-2
                  hover:shadow-xl
                `}>
                {/* HEADER */}
                <div
                  className="
                    flex
                    items-center

                    gap-4

                    mb-6
                  ">
                  {/* AVATAR */}
                  {item.photo ? (
                    <img
                      src={item.photo}
                      alt={item.name}
                      className="h-[64px] w-[64px] flex-none rounded-full object-cover"
                    />
                  ) : (
                    <div
                      className="
                      w-[64px]
                      h-[64px]

                      rounded-full

                      bg-gradient-to-br
                      from-[#3DA4A8]
                      to-[#2C4858]

                      flex
                      items-center
                      justify-center

                      text-white
                      text-[20px]
                      font-bold
                    ">
                      {item.name.charAt(0)}
                    </div>
                  )}

                  {/* NAME */}
                  <h3
                    className="
                      text-[#324A5A]

                      text-[20px]
                      font-semibold
                    ">
                    {item.name}
                  </h3>
                </div>

                {/* MESSAGE */}
                <p
                  className="
                    text-[#4B5563]

                    text-[15px]
                    leading-[28px]
                  ">
                  “{item.message}”
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
